<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import providerApi from '@/services/api/provider.api'
import thrpyApi from '@/services/api/thrpy.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Visitas Registradas',
      routes: ['Informes', 'Visitas Registradas'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          errors: [
            { id: true, name: 'Sí' },
            { id: false, name: 'No' },
          ],
          months: [],
          providers: [],
          specialists: [],
          centers: [],
          visitDate: null,
        },
        filters: {
          academicYear: null,
          error: null,
          month: null,
          provider: null,
          specialist: null,
          center: null,
          sie: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
          class: 'col-md-3',
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Mes',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un mes.',
          validations: 'required',
          options: this.model.search.collections.months,
          value: this.model.search.filters.month,
          class: 'col-md-3',
          disabled: this.model.search.collections.months.length <= 0,
          onChanged: this.onChangeMonth,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un proveedor.',
          validations: 'required',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          class: 'col-md-6',
          disabled:
            this.isProviderFilterDisabled ||
            this.model.search.collections.providers.length <= 1,
          onChanged: this.onChangeProvider,
        },
        {
          name: 'specialist',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Especialista',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.specialists,
          value: this.model.search.filters.specialist,
          class: 'col-md-6',
          disabled:
            this.model.search.collections.specialists.length <= 1,
        },
        {
          name: 'center',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Centro',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un centro.',
          validations: 'required',
          options: this.model.search.collections.centers,
          value: this.model.search.filters.center,
          class: 'col-md-3',
          disabled: this.model.search.collections.centers.length <= 0,
        },
        {
          name: 'error',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Error',
          placeholder: 'Seleccionar',
          clearable: false,
          options: this.model.search.collections.errors,
          value: this.model.search.filters.error,
          class: 'col-md-3',
        },
        {
          name: 'sie',
          component: 'CustomInput',
          type: 'text',
          label: 'SIE',
          placeholder: 'Escriba número de SIE',
          icon: 'fa fa-search orange-icon',
          class: 'col-md-3',
          leftIcon: true,
          value: this.model.search.filters.sie,
          disabled: this.model.search.filters.sieDisabled,
        },
        {
          name: 'visitDate',
          component: 'custom-date-picker',
          label: 'Fecha de Visita',
          placeholder: 'Seleccione Fecha',
          class: 'col-md-3',
          maxDate: new Date(),
          value: this.model.search.filters.visitDate,
        },
      ]
    },
    isProviderFilterDisabled() {
      return (
        this.model.search.collections.providers?.length > 0 &&
        this.model.search.collections.providers?.some((x) => x.selected)
      )
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    async onChangeAcademicYear() {
      this.model.search.filters.month = null
      this.model.search.filters.provider = null
      this.model.search.collections.providers = []
      this.model.search.filters.center = null

      await this.getMonth()
    },
    async onChangeMonth() {
      this.model.search.filters.provider = null
      if (this.model.search.filters.month) {
        await this.getProvider()
        await this.getCenters()
      }
    },
    async onChangeProvider() {
      this.model.search.filters.specialist = null
      await this.getSpecialist()
      await this.getCenters()
    },
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears().then(
        (res) => (this.model.search.collections.academicYears = res.data)
      )
    },
    async onHandlerSearch() {
      this.process()
    },
    async process() {
      if (
        this.hasValue(this.model.search.filters.academicYear) &&
        this.hasValue(this.model.search.filters.center) &&
        this.hasValue(this.model.search.filters.month) &&
        this.hasValue(this.model.search.filters.provider)
      ) {
        await ReportServices.getReport('reportvisit', {
          academicYearId: this.model.search.filters.academicYear?.id,
          errorFlag: this.model.search.filters.error?.id,
          monthNumber: this.model.search.filters.month?.id,
          centerId: this.model.search.filters.center?.id,
          specialistId: this.model.search.filters.specialist?.id,
          visitDate: this.model.search.filters.visitDate,
          providerId: this.model.search.filters.provider?.id,
        }).then((res) => DocumentServices.Download(res.data))
      }
    },
    async getMonth() {
      await thrpyApi
        .getTherapyMonth({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          this.model.search.collections.months = res.data
        })
    },
    async getProvider() {
      await providerApi
        .getProviderCompanies({
          academicYearId: this.model.search.filters.academicYear?.id,
          month: this.model.search.filters.month?.name,
        })
        .then((res) => {
          this.model.search.collections.providers = res.data

          if (res.data.length == 1) {
            this.model.search.filters.provider = res.data[0]
            this.getSpecialist();
          } else if (res.data.length > 0) {
            const providerSelected = res.data?.find((x) => x?.selected);
            if (providerSelected) {
              this.model.search.filters.provider = providerSelected;
              this.getSpecialist();
            }
          }
        })
    },
    async getSpecialist() {
      await thrpyApi
        .getTherapyEspecialist({
          academicYearId: this.model.search.filters.academicYear?.id,
          companyId: this.model.search.filters.provider?.id,
        })
        .then((res) => {
          this.model.search.collections.specialists = res.data

          if (res.data.length == 1) {
            this.model.search.filters.specialist = res.data[0]
          }
        })
    },
    async getCenters() {
      await providerApi.getProviderCenters({
        academicYearId: this.model.search.filters.academicYear?.id,
        month: this.model.search.filters.month.name,
        companyId: this.model.search.filters.provider.id,
        specialistId: this.model.search.filters.specialist?.id,
        onlyUseBillingCenter: true, // for returning billingCenterId and isBillingFlag true instead of centerId 
      }).then((res) => (this.model.search.collections.centers = res.data))
    },
    hasValue(paramValue) {
      return paramValue !== null && paramValue !== undefined
    },
  },
}
</script>
